export default __webpack_public_path__ + "static/media/me3_Globe.94650180.svg";